if (!customElements.get('tandoori-assistant')) {
  customElements.define('tandoori-assistant', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const local = ['127.0.0.1', 'localhost'].includes(location.hostname);
      const configured = this.dataset.endpoint || (local ? 'http://127.0.0.1:9293' : '');
      if (!configured) return; // Unconfigured assistant stays hidden outside local preview.
      try {
        const endpoint = new URL(configured);
        if (endpoint.protocol !== 'https:' && !(local && endpoint.origin === 'http://127.0.0.1:9293')) return;
        this.endpoint = endpoint.href.replace(/\/$/, '');
      } catch { return; }
      this.hidden = false;
      this.messages = [];
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-ai-input]');
      this.send = this.querySelector('[data-ai-send]');
      this.status = this.querySelector('[data-ai-status]');
      this.log = this.querySelector('[data-ai-log]');
      this.querySelector('[data-ai-open]').addEventListener('click', () => { this.dialog.showModal(); this.check(); });
      this.querySelector('[data-ai-close]').addEventListener('click', () => this.dialog.close());
      this.querySelectorAll('[data-ai-prompt]').forEach(button => button.addEventListener('click', () => { this.input.value = button.textContent; this.input.focus(); }));
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.ask(); });
    }

    async check() {
      if (this.busy) return;
      this.send.disabled = true;
      this.status.textContent = this.dataset.thinking;
      try {
        const response = await fetch(`${this.endpoint}/health`, { signal: AbortSignal.timeout(5000), credentials: 'omit' });
        this.ready = response.ok && (await response.json()).ready === true;
      } catch { this.ready = false; }
      this.status.textContent = this.dataset[this.ready ? 'ready' : 'offline'];
      this.send.disabled = !this.ready;
    }

    append(role, text) {
      const message = document.createElement('div');
      message.className = `tb-ai-message${role === 'user' ? ' tb-ai-message--user' : ''}`;
      const label = document.createElement('strong');
      label.textContent = role === 'user' ? this.dataset.you : this.dataset.name;
      message.append(label, document.createTextNode(text));
      this.log.append(message);
    }

    async ask() {
      const text = this.input.value.trim();
      if (!this.ready || this.busy || !text || text.length > 1600) return;
      this.busy = true; this.send.disabled = true;
      this.status.textContent = this.dataset.thinking;
      this.append('user', text);
      this.input.value = '';
      // Bound both turns and character count; history stays only in this page's memory.
      const history = [...this.messages.slice(-4), { role: 'user', content: text }];
      while (history.reduce((n, m) => n + m.content.length, 0) > 8500) history.shift();
      try {
        const response = await fetch(`${this.endpoint}/chat`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', signal: AbortSignal.timeout(65000),
          body: JSON.stringify({ messages: history, productPath: location.pathname.startsWith('/products/') ? location.pathname : '' }),
        });
        if (!response.ok) throw new Error('Unavailable');
        const result = await response.json();
        if (typeof result.answer !== 'string' || !Array.isArray(result.products)) throw new Error('Invalid answer');
        this.append('assistant', result.answer);
        this.messages = [...history, { role: 'assistant', content: result.answer.slice(0, 1600) }];
        const cards = document.createElement('div'); cards.className = 'tb-ai-products';
        for (const product of result.products.slice(0, 3)) {
          if (!/^\/products\/[a-z0-9%_-]+\?variant=\d+$/i.test(product.url)) continue;
          const link = document.createElement('a'); link.className = 'tb-ai-product'; link.href = product.url;
          if (product.image) {
            const imageUrl = new URL(product.image.startsWith('//') ? `https:${product.image}` : product.image, location.origin);
            if (imageUrl.origin === location.origin || (imageUrl.protocol === 'https:' && ['cdn.shopify.com', 'wi9rgr-id.myshopify.com'].includes(imageUrl.hostname))) {
              const image = document.createElement('img'); image.src = imageUrl.href; image.alt = ''; image.width = 48; image.height = 64; image.loading = 'lazy'; link.append(image);
            }
          }
          const info = document.createElement('div'), title = document.createElement('span'), price = document.createElement('small');
          title.textContent = product.title; price.textContent = product.money; info.append(title, price); link.append(info); cards.append(link);
        }
        this.log.append(cards);
        this.status.textContent = this.dataset.ready;
      } catch {
        this.status.textContent = this.dataset.error;
        this.input.value = text;
      } finally {
        this.busy = false; this.send.disabled = !this.ready;
        this.status.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        this.input.focus({ preventScroll: true });
      }
    }
  });
}
